import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemActivityCardComponent } from './system-activity-card.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MapSystemActivityModule } from './map-system-activity/map-system-activity.module';
import { ColumnChartActivitySystemModule } from './column-chart-activity-system/column-chart-activity-system.module';
import { MatStepperModule } from '@angular/material/stepper';

@NgModule({
    declarations: [SystemActivityCardComponent],
    exports: [SystemActivityCardComponent],
    imports: [CommonModule, MatCardModule, MapSystemActivityModule, MatIconModule, MatStepperModule, ColumnChartActivitySystemModule]
})
export class SystemActivityCardModule {}
